"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeline = exports.getDetails = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const API_SH_BACKEND_APIKEY = 'apikey 50f157ef-620d-4cf2-9fb8-bfa0ead3f013';
const urlMapping = {
    details: {
        client: 'api/sh/order/details',
    },
    timeline: {
        client: 'api/sh/order/timeline',
    },
};
const getDetails = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { hash }) {
    var _c;
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.details, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        headers: {
            Authorization: API_SH_BACKEND_APIKEY,
        },
        params: Object.assign(Object.assign({}, defaultRequestParams), { hash }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return (_c = result.data) === null || _c === void 0 ? void 0 : _c.data;
});
exports.getDetails = getDetails;
const getTimeline = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { hash }) {
    var _c;
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.timeline, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        headers: {
            Authorization: API_SH_BACKEND_APIKEY,
        },
        params: Object.assign(Object.assign({}, defaultRequestParams), { hash }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return (_c = result.data) === null || _c === void 0 ? void 0 : _c.data;
});
exports.getTimeline = getTimeline;
//# sourceMappingURL=tracking.api.js.map